import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table, Container, Row, Col } from "react-bootstrap";
import BlockTitle from "../../components/layout/blockTitle/BlockTitle";
import GetData from "../../services/getData";
import TitleWithIcon from "../../components/layout/pageTitle/PageTitle";
import templateIcon from "../../media/template_plan.png";

function TreatmentRecommend() {
    const { t } = useTranslation("templates");
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadTemplates = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await GetData({
                module: "templates",
                block: "recommendations",
                action: "list",
            });

            const list =
                data?.result ??
                data?.request?.result ??
                [];

            setTemplates(Array.isArray(list) ? list : []);
        } catch (err) {
            console.error("Ошибка загрузки шаблонов рекомендаций:", err);
            setError(err.message || t("recommendList.loadFailed"));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = t("recommendList.title");
        loadTemplates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t]);

    const handleAddClick = () => {
        navigate("/templates/recommendation/new");
    };

    const handleOpenTemplate = (template) => {
        const id = template?.id?.value ?? template?.id;
        if (id != null) {
            navigate(`/templates/recommendation/${id}`);
        }
    };

    if (loading && templates.length === 0) {
        return (
            <Container fluid="md" className="mt-4">
                {t("state.loading", { ns: "common" })}
            </Container>
        );
    }

    if (error) {
        return (
            <Container fluid="md" className="mt-4 text-danger">
                {t("error", { ns: "common", message: error })}
            </Container>
        );
    }

    return (
        <Container fluid="md">
            <Row>
                <Col>
                    <BlockTitle
                        title={
                            <TitleWithIcon
                                icon={templateIcon}
                                title={t("recommendList.title")}
                                showStatus={false}
                                status={""}
                            />
                        }
                        buttons={[
                            {
                                label: t("recommendList.create"),
                                onClick: handleAddClick,
                                type: "normal",
                            },
                        ]}
                    />
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="page">
                        <div className="page-content">
                            <div className="page-block table-list">
                                {templates.length === 0 ? (
                                    <div className="no-patients">
                                        {t("recommendList.notFound")}
                                    </div>
                                ) : (
                                    <Table className="main-table-list rounded-table">
                                        <thead>
                                            <tr>
                                                <th>{t("recommendList.colName")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {templates.map((tpl) => {
                                                const tplId = tpl?.id?.value ?? tpl?.id;
                                                const title =
                                                    tpl?.title?.value ??
                                                    tpl?.title ??
                                                    "—";
                                                return (
                                                    <tr
                                                        key={tplId}
                                                        className="clickable-row"
                                                        onClick={() => handleOpenTemplate(tpl)}
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                e.preventDefault();
                                                                handleOpenTemplate(tpl);
                                                            }
                                                        }}
                                                    >
                                                        <td>{title}</td>
                                                    </tr>
                                                );
                                            })}
                                            <tr className="table-summary">
                                                <td className="summary-cell">
                                                    {t("recommendList.found", { count: templates.length })}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default TreatmentRecommend;

